// This must be a CommonJS module because knockout is aliased to this.

const ko = require('knockout.base');
const { lazyObservable, waitForValueAsync, promiseObserver, withPausing, preprocessNode, asyncComputed, recursiveUnwrap, rateLimit, lazyObservableArray } = require('KnockoutExtensions');

ko.lazyObservable = lazyObservable;

ko.lazyObservableArray = lazyObservableArray;

ko.asyncComputed = asyncComputed;

ko.waitForValueAsync = waitForValueAsync;

ko.recursiveUnwrap = recursiveUnwrap;

ko.extenders.rateLimit = rateLimit;

ko.promiseObserver = promiseObserver;

ko.observable.fn.withPausing = function () {
	return withPausing(this);
};

ko.bindingProvider.instance.preprocessNode = preprocessNode;

module.exports = ko;
